// Helper to convert Chakra semantic token to CSS variable
const toVar = (token: string) =>
  `var(--chakra-colors-${token.replace(/\./g, '-')})`

export const createCustomStyles = (mode: 'light' | 'dark') => ({
  control: (base: any) => ({
    ...base,
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    minHeight: '40px',
    cursor: 'pointer',
    '&:hover': {
      border: 'none',
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0',
  }),
  placeholder: (base: any) => ({
    ...base,
    color: toVar(`text.input-value.${mode}`),
    fontSize: '14px',
    fontWeight: 400,
    margin: 0,
  }),
  input: (base: any) => ({
    ...base,
    color: toVar(`text.primary.${mode}`),
    margin: 0,
    padding: 0,
  }),
  singleValue: (base: any) => ({
    ...base,
    color: toVar(`text.primary.${mode}`),
    margin: 0,
  }),
  multiValue: (base: any) => ({
    ...base,
    backgroundColor: 'transparent',
    margin: 0,
  }),
  multiValueLabel: (base: any) => ({
    ...base,
    padding: 0,
  }),
  multiValueRemove: (base: any) => ({
    ...base,
    display: 'none',
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    padding: '0',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    padding: '0 4px',
    marginTop: '4px',
    color: toVar(`text.primary.${mode}`),
  }),
  clearIndicator: (base: any) => ({
    ...base,
    padding: '0 4px',
    marginTop: '4px',
    color: toVar(`text.primary.${mode}`),
  }),
  menu: (base: any) => ({
    ...base,
    backgroundColor: toVar(`bg.input.${mode}`),
    borderRadius: '6px',
    zIndex: 9999,
    // Account for the parent container's padding
    width: 'calc(100% + 24px)',
    left: '-12px',
    marginTop: '4px',
  }),
  menuList: (base: any) => ({
    ...base,
    padding: '4px',
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isFocused
      ? toVar(`border.input-hover.${mode}`)
      : 'transparent',
    color: toVar(`text.primary.${mode}`),
    fontSize: '14px',
    fontWeight: 500,
    borderRadius: '4px',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: toVar(`border.input-hover.${mode}`),
    },
  }),
  noOptionsMessage: (base: any) => ({
    ...base,
    color: toVar(`text.input-value.${mode}`),
  }),
})
